import { render, staticRenderFns } from "./ComformDialog.vue?vue&type=template&id=3b458b12&scoped=true"
import script from "./ComformDialog.vue?vue&type=script&lang=js"
export * from "./ComformDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b458b12",
  null
  
)

export default component.exports